import React from 'react';

const Footer = () =>{
    return(
        <>
            <div className='w-100 d-flex justify-content-around m-0 p-2 mt-3' style={{"backgroundColor":"var(--main-color)", "color":"var(--light-color)"}}>
                <div className='d-flex'>
                    <a className='m-1' href="https://github.com/Ahmed-Osama-Fawzy" target='_blank' rel="noreferrer"><i class="fa-brands fa-github"></i></a>
                    <a className='m-1' href="https://www.linkedin.com/in/ahmed-osama-289bb0288" target='_blank' rel="noreferrer"><i class="fa-brands fa-linkedin"></i> </a>
                    <a className='m-1' href="mailto:ahmd.osama2611@gmail.com" target='_blank' rel="noreferrer"><i class="fa-solid fa-envelope"></i> </a>
                </div>
                <div className='d-block'> © 2025 A.Osama. All rights reserved.</div>
            </div>
        </>
    )
}

export default Footer;